export var BuilderContentType;
(function (BuilderContentType) {
    BuilderContentType["Text"] = "text";
    BuilderContentType["SelectImmediate"] = "select-immediate";
    BuilderContentType["Select"] = "select";
    BuilderContentType["DocumentSelect"] = "document-select";
    BuilderContentType["Media"] = "media";
    BuilderContentType["MediaAudio"] = "media-audio";
    BuilderContentType["MediaVideo"] = "media-video";
    BuilderContentType["MediaDocument"] = "media-document";
    BuilderContentType["UserInput"] = "user-input";
    BuilderContentType["ChatState"] = "chat-state";
    BuilderContentType["askLocation"] = "ask-location";
    BuilderContentType["sendLocation"] = "send-location";
    BuilderContentType["webLink"] = "web-link";
    BuilderContentType["HttpContent"] = "http-content";
    BuilderContentType["RawContent"] = "raw-content";
    BuilderContentType["SurveyType"] = "survey-content";
    BuilderContentType["Sticker"] = "media-sticker";
    BuilderContentType["ReceiveCallRequest"] = "receive-call-request";
})(BuilderContentType || (BuilderContentType = {}));
